import { Component,OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { UserService } from 'src/app/services/user.service';
import { CustomValidatorsService } from 'src/app/services/custom-validators.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Router ,ActivatedRoute} from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';
import { startWith } from 'rxjs/internal/operators/startWith';
import { City, Country, State, StaticdataService } from 'src/app/services/staticdata.service';
import { DialogService } from 'src/app/util/dialog/dialog.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import {ReportingConfigService} from 'src/app/services/reporting-config.service'
import {AirManagementService}  from 'src/app/services/air-management.service'
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { UserprofileService } from 'src/app/services/userprofile.service';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { OverlayPanel } from 'primeng/overlaypanel';
import { FileUploadHandlerEvent } from 'primeng/fileupload';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}
@Component({
  selector: 'app-user-update',
  templateUrl: './user-update.component.html',
  styleUrls: ['./user-update.component.css']
})
export class UserUpdateComponent implements OnInit {
  CountryFormControl! : FormControl; 
  CountryVisaFormControl!:FormControl;
  addressCountryFormControl! : FormControl; 
  addressStateFormControl! : FormControl;
  addressCityFormControl! : FormControl;
  postalCodeFormCountol !: FormControl;
  countryFilteredOption: Observable<Country[]>|undefined;
  countryVisaFilteredOption:Observable<Country[]>|undefined;
  countryFilteredOptions: Observable<Country[]>|undefined;
  stateFilteredOptions: Observable<State[]>|undefined;
  cityFilteredOptions: Observable<String[]>|undefined;
  
  gstvalue:any=[]
  tenantsList:any=[]

  userinfoFg !:FormGroup
  userGstFg !:FormGroup
  userCardFg !:FormGroup

  contactinfoFg!:FormGroup
  profileFg!:FormGroup
  userData:any={};
  userProfileData:any
  disableInfosave:boolean=false
  disableGstsave:boolean=true
  disableContactsave:boolean=false;
  showOrganization:boolean=false;
  showGst:boolean=false
  private subs! : Subscription;
  userType:boolean=false;
  userTyp:any;
  loginUserType:any
  userUuid:any
 constructor(private DialogService:DialogService,private PaymentConfigService:PaymentConfigService,private userProfileService:UserprofileService,private DataEntityService:ReportingConfigService,private fb : FormBuilder,private router:Router,private route:ActivatedRoute,private staticDataService : StaticdataService,private userinfoservice :UserInfoService,
  private userService : UserService,private location: Location,private AirManagementService:AirManagementService,
    private toastMsgService : ToastmsgService,private userPrivileges:UserPrivilegeService,
    private customValidator : CustomValidatorsService,){

      this.cardTypeList()
      this.bankList()
      this.creditList()
      this.loginUserType=sessionStorage.getItem('loginUserType')
    this.loginUserType=this.loginUserType.toUpperCase()
    this.userUuid=userinfoservice.getUserUuid()
      this.branchList()
      this.tenantslist()
this.businessGrouplist()
      this.userPrivileges.userPrivilegesByModule('User-Role').then((privileges:any) => {
        this.privilegesValue(privileges)
      })
      .catch((error:any) => {
      console.error(error); // Handle errors, if any
      });

      
      this.userTyp=userinfoservice.getUserType();
   this.subs = new Subscription();
   this.subs.add(
     this.userinfoservice.getUserInfoSubs().subscribe({next : (u : UserInfo) => {
       this.userTyp=u.type;
     }})
   )
   this.CountryVisaFormControl = new FormControl({countryCode:"IN",countryName : "India"},[Validators.required,this.customValidator.countryValidator()]);

   this.CountryFormControl = new FormControl({countryCode:"IN",countryName : "India"},[Validators.required,this.customValidator.countryValidator()]);

   this.addressCountryFormControl = new FormControl({countryCode:"IN",countryName : "India"},[Validators.required,this.customValidator.countryValidator()]);
   this.addressStateFormControl = new FormControl({stateCode:'',stateName:''},[Validators.required,this.customValidator.stateValidator(this.addressCountryFormControl)]);
   this.addressCityFormControl = new FormControl('',[Validators.required]);
   this.postalCodeFormCountol = new FormControl('',this.customValidator.postalCodeValidator(this.addressCountryFormControl));
             
      

 }
 email:any=[]
 pageType:any
 ngOnInit(): void  {
  
 

  this.route.queryParams.subscribe(params => {
  let data:any
  data=params
  this.email=this.decodeTransformedEmail(data.email)
//  console.log(this.email)
 // for(let i=0 ;i <data.length; i++){ this.email +=data[i]; }
  this.getUserData();

this.blankdataFields()
 //this.userDataFields();
  

    });
    
   
}
decodeTransformedEmail(encodedEmail: string): string {
  let result = '';

  for (let i = 0; i < encodedEmail.length; i += 2) {
    const hexChar = encodedEmail.slice(i, i + 2);
    const charCode = parseInt(hexChar, 16); // Convert the hexadecimal string to a character code
    result += String.fromCharCode(charCode);
  }

  return result;
}
_filterCountry(countryName: string): Country[] {
  return this.staticDataService.countryCache.filter(option =>
    option.countryName.toLowerCase().indexOf(countryName.toLowerCase()) === 0);
}
_filterState(stateName: string): State[] {
  return this.staticDataService.stateCache.filter(option =>
    option.stateName.toLowerCase().indexOf(stateName.toLowerCase()) === 0);
}

_filterCity(cityName: string): String[] {
  return this.staticDataService.cityCache.filter(option =>
    this.addressStateFormControl?.value?.stateCode ==option.stateCode 
    && option.cityName.toLowerCase().indexOf(cityName.toLowerCase()) === 0).map(c => c.cityName);
}

objectToArray(obj: Record<string, string>): string[] {
  return Object.values(obj);
}
blankdataFields(){

  this.profileFg=this.fb.group({
    "employeeCode" : [""],
    "band":[""],
    "department":[""],
    "projectCode":[""],
    "costCenter":[""],
    "billingEntity":[""],
    "supervisorCodes":[""],
    "location":[""],
    "designation":[""],
    "metaInfo":[""],
    "domesticEligibility":[""],
    "internationalEligibility":[""],
"approver":[""],
"approvalLimit":[0],
"dateOfTermination":[''],
"dateOfJoining":[''],

    "title" :  ["",[Validators.required]],
    "gender":[""],
    "firstName" :  [""],
    "middleName" :  [""],
    "lastName" :  ["",[Validators.required]],
    "dob":[""],
    "nationality":[''],
   "residencyCountry":[''],
   "travelArranger1":[''],
   "travelArranger2":[''],
   "executiveAssistants":[''],
   "delegatingSupervisor":[''],
   "profileType":[''],

    "domMealPref" :  [""],
    "domSeatPref" :  [""],
    "domSpecialPref" :[""],
    "intlMealPref" :  [""],
    "intlSeatPref" :  [""],
    "intlSpecialPref" :[""],

    "queueNo" :[""],
    "ownerPCC" :[""],
    "osi" :[""],
    "extraCommands" :[""],



    reportingDetails: this.fb.group({
      fareOption1: [''],
      fareOption2: [''],
      fareOption3: [''],
      reference: [''],
      ioPidNo: [''],
      indentDocNo: [''],
      bookedBy: [''],
      cod3: [''],
      reasonForTravel: [''],
      missedSavings: [''],
      globalId: [''],
      fareType: [''],
      fareRestriction: [''],
      cod1: [''],
      cod2: [''],
      cfoApprovalLessThan7Days: [''],
      billability: [''],
      sapCode: [ '']

    })
  });

  this.userinfoFg=this.fb.group({
    "name" : ["",[Validators.required]],
    "email" :  ["",[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
    "mobile" : ["",[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    "status":["",[Validators.required]],
    "accountCode":[''],
    "branchId":[''],
    "businessGroupCode":[null],
    "roleId":[[]],
    "emailAllowed":[false],
    "showTicketPricing":[false],
    "personalBookingAllowed":[false],



  });
  this.userCardFg=this.fb.group({
    "cardType":['',[Validators.required]],
    "bankName":['',[Validators.required]],
    "cardNumber":['',[Validators.required]],
    "expiryDate" : ['',[Validators.required,this.mmYyyyValidator]],
"holderName":['',[Validators.required]],
    

  })
 
  this.userGstFg=this.fb.group({
    "gstNumber":['',[Validators.required]],
    "gstHolderEmail" :  ['',[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
    "gstHolderName" : ['',[Validators.required]],
    "gstPhone" : ['',[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    "gstAddress":['',[Validators.required]],
    "gstCode":[''],
  })
  // console.log(this.addressStateFormControl)
  this.contactinfoFg=this.fb.group({
    "ccEmails" :  ["",[Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
    "street" : [""],
    "country":this.addressCountryFormControl,
    "state":this.addressStateFormControl,
    "city":this.addressCityFormControl,
    "pincode":this.postalCodeFormCountol,
    "phone" : ["",[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    "stateText":['']
  });
 
}

userDataFields(){
  
  
 let item:any= {name:'',email:'',mobile:'',status:'',country:'',city:'',state:'',pincode:''}
 if(this.userData){
 item=this.userData}

 
if(item.state && item.country){


  let state=this._filterStateByCode(item.state)
  let country=this._filterCountryByCode(item.country)
  // console.log(country)
  // console.log(state)
  this.addressCountryFormControl = new FormControl({countryCode:country[0]?.countryCode,countryName : country[0]?.countryName},[Validators.required,this.customValidator.countryValidator()]);
 this.addressStateFormControl = new FormControl({stateCode:state[0]?.stateCode,stateName:state[0]?.stateName},[Validators.required,this.customValidator.stateValidator(this.addressCountryFormControl)]);
 this.addressCityFormControl = new FormControl(item?.city,[Validators.required]);
 this.postalCodeFormCountol = new FormControl(item?.pincode,this.customValidator.postalCodeValidator(this.addressCountryFormControl));
           
}


this.countryVisaFilteredOption=this.CountryVisaFormControl?.valueChanges
.pipe(
  startWith({} as Country),
  map((country :Country) => country && typeof country === 'object' ? country.countryName : country),
  map((countryName: string) => countryName ? this._filterCountry(countryName) : this.staticDataService.countryCache.slice())
);
  this.countryFilteredOption=this.CountryFormControl?.valueChanges
  .pipe(
    startWith({} as Country),
    map((country :Country) => country && typeof country === 'object' ? country.countryName : country),
    map((countryName: string) => countryName ? this._filterCountry(countryName) : this.staticDataService.countryCache.slice())
  );
 this.countryFilteredOptions = this.addressCountryFormControl?.valueChanges
  .pipe(
    startWith({} as Country),
    map((country :Country) => country && typeof country === 'object' ? country.countryName : country),
    map((countryName: string) => countryName ? this._filterCountry(countryName) : this.staticDataService.countryCache.slice())
  );
  
this.stateFilteredOptions = this.addressStateFormControl?.valueChanges

  .pipe(
    startWith({} as State),
    map((state :State) => state && typeof state === 'object' ? state.stateName : state),
    map((stateName: string) => stateName ? this._filterState(stateName) : this.staticDataService.stateCache.slice())
  );
  this.cityFilteredOptions = this.addressCityFormControl?.valueChanges
  
  .pipe(
    startWith({} as City),
    map((city :City) => city && typeof city === 'object' ? city.cityName : city),
    map((cityName: string) => cityName ? this._filterCity(cityName) : this.staticDataService.cityCache.slice().map(c => c.cityName))
  );
 if(this.userData.userType==='STAFF'){
  item.branchId=item?.branchId?.split(',')
  this.userinfoFg=this.fb.group({
    "name" : [item?.name,[Validators.required]],
    "email" :  [item?.email,[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
    "mobile" : [item?.mobile,[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    "status":[item?.status,[Validators.required]],
    "accountCode":[item?.accountCode],
   "branchId":[item?.branchId],
    "roleId":[item?.roleId],
    "whitelabelId":[item?.whitelabelId],
    "businessGroupCode":[item?.businessGroupCode],
    "personalBookingAllowed":[item?.personalBookingAllowed],

    
  });
 }else{
  this.userinfoFg=this.fb.group({
    "name" : [item?.name,[Validators.required]],
    "email" :  [item?.email,[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
    "mobile" : [item?.mobile,[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    "status":[item?.status,[Validators.required]],
    "accountCode":[item?.accountCode],
    "branchId":[item?.branchId],
    "roleId":[item?.roleId],
    "businessGroupCode":[item?.businessGroupCode],
    "emailAllowed":[item?.emailAllowed],
    "showTicketPricing":[item?.showTicketPricing],
    "personalBookingAllowed":[item?.personalBookingAllowed],
  });
}
 
  this.userGstFg=this.fb.group({
    "gstNumber":['',[Validators.required]],
    "gstHolderEmail" :  ['',[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
    "gstHolderName" : ['',[Validators.required]],
    "gstPhone" : ['',[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    "gstAddress":['',[Validators.required]],
    "gstCode":[''],
  })
  // console.log(this.addressStateFormControl)
  this.contactinfoFg=this.fb.group({
    "ccEmails" :  [item.ccEmails,[Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
    "street" : [item.street],
    "country":this.addressCountryFormControl,
    "state":this.addressStateFormControl,
    "city":this.addressCityFormControl,
    "pincode":this.postalCodeFormCountol,
    "phone" : [item?.phone,[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    "stateText":[ this.addressCountryFormControl.value.countryName]

  });
 
  this.profileFg=this.fb.group({
    "username":[this.userData.userName],
    "bookingProfileUuid":[this.userProfileData?.bookingProfileUuid],

    "employeeCode" : [this.userProfileData?.employeeCode],
    "band":[this.userProfileData?.band],
    "department":[this.userProfileData?.department],
    "billingEntity":[this.userProfileData?.billingEntity],
    "supervisorCodes":[this.userProfileData?.supervisorCodes?.split(',')||[]],
    "costCenter":[this.userProfileData?.costCenter],
    "projectCode":[this.userProfileData?.projectCode],
    "location":[this.userProfileData?.location],
    "designation":[this.userProfileData?.designation],
    "metaInfo":[this.userProfileData?.metaInfo],
    "domesticEligibility":[this.userProfileData?.domesticEligibility],
    "internationalEligibility":[this.userProfileData?.internationalEligibility],
    "approver":[this.userProfileData?.approver.toString()],
    "approvalLimit":[this.userProfileData?.approvalLimit],
    "dateOfTermination":[this.userProfileData?.dateOfTermination],
    "dateOfJoining":[this.userProfileData?.dateOfJoining],
    "gender":[this.userProfileData?.gender],

    "title" :  [this.userProfileData?.title,[Validators.required]],
    "firstName" :  [this.userProfileData?.firstName],
    "middleName" :  [this.userProfileData?.middleName],
    "lastName" :  [this.userProfileData?.lastName,[Validators.required]],
    "dob":[this.userProfileData?.dob],
   "nationality":[this.userProfileData?.nationality],
   "residencyCountry":[this.userProfileData?.residencyCountry],
   "travelArranger1":[this.userProfileData?.travelArranger1],
   "travelArranger2":[this.userProfileData?.travelArranger2],
   "executiveAssistants":[this.userProfileData?.executiveAssistants],
   "delegatingSupervisor":[this.userProfileData?.delegatingSupervisor],
   "profileType":[this.userProfileData?.profileType],




 "domMealPref" :  [this.userProfileData?.domMealPref],
    "domSeatPref" :  [this.userProfileData?.domSeatPref],
    "domSpecialPref" :[this.userProfileData?.domSpecialPref],
    "intlMealPref" :  [this.userProfileData?.intlMealPref],
    "queueNo" :[this.userProfileData?.queueNo],
    "ownerPCC" :[this.userProfileData?.ownerPCC],
    "osi" :[this.userProfileData?.osi],
    "extraCommands" :[this.userProfileData?.extraCommands],
    "intlSeatPref" :  [this.userProfileData?.intlSeatPref],
    "intlSpecialPref" :[this.userProfileData?.intlSpecialPref],
    reportingDetails: this.fb.group({
      fareOption1: [this.userProfileData?.reportingDetails?.fareOption1 || ''],
      fareOption2: [this.userProfileData?.reportingDetails?.fareOption2 || ''],
      fareOption3: [this.userProfileData?.reportingDetails?.fareOption3 || ''],
      reference: [this.userProfileData?.reportingDetails?.reference || ''],
      ioPidNo: [this.userProfileData?.reportingDetails?.ioPidNo || ''],
      indentDocNo: [this.userProfileData?.reportingDetails?.indentDocNo || ''],
      bookedBy: [this.userProfileData?.reportingDetails?.bookedBy || ''],
      cod3: [this.userProfileData?.reportingDetails?.cod3 || ''],
      reasonForTravel: [this.userProfileData?.reportingDetails?.reasonForTravel || ''],
      missedSavings: [this.userProfileData?.reportingDetails?.missedSavings || ''],
      globalId: [this.userProfileData?.reportingDetails?.globalId || ''],
      fareType: [this.userProfileData?.reportingDetails?.fareType || ''],
      fareRestriction: [this.userProfileData?.reportingDetails?.fareRestriction || ''],
      cod1: [this.userProfileData?.reportingDetails?.cod1 || ''],
      cod2: [this.userProfileData?.reportingDetails?.cod2 || ''],
      cfoApprovalLessThan7Days: [this.userProfileData?.reportingDetails?.cfoApprovalLessThan7Days || ''],
      billability: [this.userProfileData?.reportingDetails?.billability || ''],
      sapCode: [this.userProfileData?.reportingDetails?.sapCode || '']
    })
  
   
  });
}

privilegesView:any
privilegesValue(privs:any){
 
  let privileges="";

if(privs.includes('view')){
  this.privilegesView="VAMD"
}else{
  this.privilegesView="AccessDenied"
}

}



_filterStateByCode(stateCode: string): State[] {
  return this.staticDataService.stateCache.filter(option =>
    option.stateCode.toLowerCase().indexOf(stateCode.toLowerCase()) === 0);
}
_filterCountryByCode(countryCode: string): Country[] {
  return this.staticDataService.countryCache.filter(option =>
    option.countryCode.toLowerCase().indexOf(countryCode.toLowerCase()) === 0);
}
displayCountrySelectionFn(country : Country) {
  return country ? country.countryName : "";
}

displayStateSelectionFn(state : State) {
  
  return state ? state.stateName : "";
}
updateUserInfo() {
  this.disableInfosave=true
  if(this.userData.userType==='STAFF'){
    // console.log(this.userinfoFg.value.branchId)
    if(this.userinfoFg.value.branchId){
    this.userinfoFg.value.branchId=this.userinfoFg.value.branchId.join(',')
    }
  }
  console.log(this.userinfoFg.value.branchId)
  // this.userinfoFg.value.roleId=this.userinfoFg.value.roleId?.join()
  this.userService.updateUserInfo(this.userinfoFg.value,this.userData.email)
    .subscribe({
      next : (res) => {
        if(res.status==200 || res.status==201) {
          this.toastMsgService.setMsg({msg : "User Updated Successfully!",msgTitle : "Success", msgType : "I"});
          this.getUserData();

        } else {
          this.getUserData();

          const body : any = res.body;
          this.registerUserErrorMsg(res.status,body?.result);
        } 
        this.disableInfosave=false

      },error : (err) => {
        this.disableInfosave=false
        this.getUserData();

        this.registerUserErrorMsg(err.status,err.error);
      }
    }
  )
}

registerUserErrorMsg(status : number,msg : string) {
  if(status >=500) {
    this.toastMsgService.setMsg({msg : "Failed to Update User",msgTitle : "Warning", msgType : "W"});
  } else {

    this.toastMsgService.setMsg({msg : "Failed to Update User",msgTitle:  "Warning", msgType : "W"});
  } 
}

submitGst(){
 
  console.log(this.userGstFg.value)
this.gstvalue.push(this.userGstFg.value)
this.userGstFg=this.fb.group({
  "gstNumber":['',[Validators.required]],
  "gstHolderEmail" :  ['',[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
  "gstHolderName" : ['',[Validators.required]],
  "gstPhone" : ['',[Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
  "gstAddress":['',[Validators.required]],
  "gstCode":[''],
})
if(this.gstvalue.length>0){
  this.disableGstsave=false
}else{
  this.disableGstsave=true

}
}

updateGstUser() {
 
  this.userService.updateGstInfo({gstInfoList:this.gstvalue},this.userData.email)
    .subscribe({
      next : (res) => {
        if(res.status==200 || res.status==201) {
          this.toastMsgService.setMsg({msg : "User Updated Successfully!",msgTitle : "Success", msgType : "I"});
          this.getUserData();

        } else {
          const body : any = res.body;
          this.registerUserErrorMsg(res.status,body?.result);
          this.getUserData();

        } 
        this.disableInfosave=false

      },error : (err) => {
        this.disableInfosave=false
        this.getUserData();

        this.registerUserErrorMsg(err.status,err.error);
      }
    }
  )
}

registerGstUserErrorMsg(status : number,msg : string) {
  if(status >=500) {
    this.toastMsgService.setMsg({msg : "Failed to Update User",msgTitle : "Warning", msgType : "W"});
  } else {

    this.toastMsgService.setMsg({msg : "Failed to Update User",msgTitle:  "Warning", msgType : "W"});
  } 
}

updateContactUser() {
  this.disableContactsave=true
  this.contactinfoFg.value.country=this.addressCountryFormControl.value.countryCode
  this.contactinfoFg.value.state=this.addressStateFormControl.value.stateCode

  this.userService.updateContactInfo(this.contactinfoFg.value,this.userData.email)
    .subscribe({
      next : (res) => {
        if(res.status==200 || res.status==201) {
          this.toastMsgService.setMsg({msg : "User Updated Successfully!",msgTitle : "Success", msgType : "I"});
          this.getUserData();
        } else {
          const body : any = res.body;
          this.getUserData();

          this.registerContactUserErrorMsg(res.status,body?.result);
        } 
        this.disableContactsave=false

      },error : (err) => {
        this.disableContactsave=false
        this.getUserData();

        this.registerContactUserErrorMsg(err.status,err.error);
      }
    }
  )
}

registerContactUserErrorMsg(status : number,msg : string) {
  if(status >=500) {
    this.toastMsgService.setMsg({msg : "Failed to Update User",msgTitle : "Warning", msgType : "W"});
  } else {

    this.toastMsgService.setMsg({msg : "Failed to Update User",msgTitle:  "Warning", msgType : "W"});
  } 
}



backClick(){
  // this.location.back()
  window.close();

  // console.log(this.userTyp)
  // if( this.pageType==='profile'){
  //   //this.router.navigate(["/app/flight"]);
  //   window.location.href = "/app/flight";
  // }else{
  //   this.router.navigate(["/app/Users"]);

  // }
 
  
  
}

stateValue:any;
  countryvalue:any;
  showUserData:boolean=false
getUserData(){
  this.userService.getUserData(this.email)
  .subscribe({
    next : (res:any) => {
      if(res) {
 let data:any
 data=res
 this.showUserData=true

this.userProfileData=data?.userBookingProfile
this.visaArray=this.userProfileData?.visaDetails
this.passportArray=this.userProfileData?.passportDetails
this.frequentArray=this.revertStringToData(this.userProfileData?.frequentFlierInfo)

this.Carrierlist()

// this.passportArray.forEach((item:any)=>{
//   item.passportCountry=this.staticDataService.countryCache.filter((country:any)=>country.countryCode===item.passportCountry)[0]?.countryName
  
// })
// this.visaArray.forEach((item:any)=>{
//   item.issuingCountry=this.staticDataService.countryCache.filter((country:any)=>country.countryCode===item.issuingCountry)[0]?.countryName
// })

this.dataEntitylist()
 this.userData=data?.user
 if(this.userData.userType!='EMPLOYEE'  ){
  this.getRoleList()
  this.userType=false
 }else{
  this.getRoleTravellerList()
  this.userType=true


 }
// const stateValue = this._filterStateByCode(data.state)
// const countryValue = this._filterCountryByCode(data.country)
// console.log(countryValue[0])
// this.stateValue=stateValue[0]
//   this.countryvalue=countryValue[0]
// console.log(this.userData.gstDetails.length)
if( this.userData.gstDetails.length>0){
  this.gstvalue=this.userData?.gstDetails 
  console.log(this.gstvalue)

this.disableGstsave=false
}else{ this.disableGstsave=true 

}
 this.userDataFields()
 this.getCorporateUsers()


      } else {    
      } 
    },error : (err) => {

      console.error("Error in fetching data");
    }
  }
)
}


revertStringToData(dataString: string): any[] {
  if(dataString){
  return dataString.split('&').map(item => {
    const [Program, number, boolean] = item.split('$');
    return { Program, number, boolean: boolean === 'true' };
  });}else{
    return []
  }
}
OnClickOrg(){
  this.showOrganization=!this.showOrganization
}
showCard:boolean=false
OnClickGst(){
  this.showGst=!this.showGst
}

OnClickCard(){
  this.showCard=!this.showCard

}
convertDataToString(data: any[]): string {
  return data.map(item => `${item.Program}$${item.number}$${item.boolean}`).join('&');
}

updateProfileUser() {
//  console.log(this.frequentArray)
 if(this.profileFg.value.supervisorCodes){

 if(this.profileFg.value.supervisorCodes.length!=0){
  this.profileFg.value.supervisorCodes=this.profileFg.value.supervisorCodes.join()

 }else{
  this.profileFg.value.supervisorCodes=''

 }
 }
 this.profileFg.value.frequentFlierInfo=this.convertDataToString(this.frequentArray)
  this.profileFg.value.passportDetails=this.passportArray
  this.profileFg.value.visaDetails=this.visaArray
// this.profileFg.value.="UK$123$true&AI$123$true"
  this.userService.updateProfileInfo(this.profileFg?.value)
    .subscribe({
      next : (res) => {
        if(res.status==200 || res.status==201) {
          this.toastMsgService.setMsg({msg : "User Updated Successfully!",msgTitle : "Success", msgType : "I"});
          this.getUserData();
        } else {
          const body : any = res.body;
          this.registerprofileUserErrorMsg(res.status,body?.result);
          this.getUserData();

        } 
       

      },error : (err) => {
        
        this.getUserData();

        this.registerprofileUserErrorMsg(err.status,err.error);
      }
    }
  )
}

registerprofileUserErrorMsg(status : number,msg : string) {
  if(status >=500) {
    this.toastMsgService.setMsg({msg : "Failed to Update User",msgTitle : "Warning", msgType : "W"});
  } else {
    
    this.toastMsgService.setMsg({msg : "Failed to Update User",msgTitle:  "Warning", msgType : "W"});
  } 
}


// dataEntitylist(){

//   this.DataEntityService
//  .listEntities(this.id)
//  .subscribe({
//     next : (res:any) => {
//       if(res) {
//      let data=res
//      this.DataEntity=data
    
//       } else {
     
//       } 
//     },error : (err) => {

//   }
//   }
// )
// }
onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}
passportArray:any=[]
visaArray:any=[]
frequentArray:any=[]

addVisa(){
let addvisa={
  name:'',
visaNumber:'',
issuingCountry:'',
type:"",
issueDate:"",
expiryDate:""}
this.visaArray.push(addvisa)


if(this.visaArray.length>1){
  this.addButton=true
  }else{
    // this.addButton=false
  }
  if(this.visaArray.length>0){
    this.clearButton=true
    }else{
      this.clearButton=false
    
    }
}


clearButton:any=false
addButton:any=true

addfrequent(){
  let addvisa={
  Program:'',
  number:'',
  boolean:false
  }
  this.frequentArray.push(addvisa)
  
  
  if(this.frequentArray.length>1){
    this.addfrequentButton=true
    }else{
      // this.addButton=false
    }
    if(this.frequentArray.length>0){
      this.clearfrequentButton=true
      }else{
        this.clearfrequentButton=false
      
      }
  }
  clearfrequentButton:any=false
  addfrequentButton:any=true

  frequentClear(){

    if(this.frequentArray.length>1){
      this.clearfrequentButton=true
      }else{
        this.clearfrequentButton=false
      
      }
    this.frequentArray.splice(this.frequentArray.length - 1, 1);
  
  }
clear(){

  if(this.visaArray.length>1){
    this.clearButton=true
    }else{
      this.clearButton=false
    
    }
  this.visaArray.splice(this.visaArray.length - 1, 1);

}
filteredUser:any[]=[]
searchList(event: AutoCompleteCompleteEvent) {
  let filtered: any[] = [];
    let query = event.query;
console.log(event.originalEvent)
    for (let i = 0; i < (this.staticDataService.countryCache as any[]).length; i++) {
        let user = (this.staticDataService.countryCache as any[])[i];
        if (user.countryName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
            filtered.push(user);
        }
    }

    this.filteredUser = filtered;
    console.log(filtered)
}


onCountrySelect(event: any,item:any) {
  item.passportCountry = event.countryName;
}

onCountryVisaSelect(event: any,item:any) {
  item.issuingCountry = event.countryName;
}

addPassport(){
let addPassport={
  passportNumber:'',
  passportDOB:'',
  passportDOI:'',
  passportDOE:"",
  passportPOI:"",
  passportCountry:""
}
this.passportArray.push(addPassport)


if(this.visaArray.length>1){
  this.addPassportButton=true
  }else{
    // this.addButton=false
  }
  if(this.passportArray.length>0){
    this.clearPassportButton=true
    }else{
      this.clearPassportButton=false
    
    }
}
clearPassportButton:any=false
addPassportButton:any=true

clearPassport(){

  if(this.passportArray.length>1){
    this.clearPassportButton=true
    }else{
      this.clearPassportButton=false
    
    }
  this.passportArray.splice(this.passportArray.length-1, 1);

}


carrierList:any=[]
Carrierlist() {
  this.AirManagementService.carrierlist().subscribe({
    next: (res: any) => {
      if (res) {
        this.carrierList = res;

        // Initialize filteredCarrier and searchCarrierQuery for each row
        this.frequentArray.forEach((frequentDetail: any) => {
          frequentDetail.filteredCarrier = [...this.carrierList];
          frequentDetail.searchCarrierQuery = '';
        });
      }
    },
    error: (err) => {
      console.error('Carrier list fetch failed', err);
    }
  });
}

roleList:any=[]
getRoleList(){
  this.userService
  .getRoleList()
  .subscribe({
    next : (res:any) => {
      if(res) {
        const data = res
       this.roleList=data.result
      //  console.log('ROLE')
       } else {

       } 
    },error : (err) => {

      console.error("Error in fetching all getRoleList");
    }
  }
)
}
getRoleTravellerList(){
  this.userService
  .getRoleTravellerList()
  .subscribe({
    next : (res:any) => {
      if(res) {
        const data = res
       this.roleList=data.result
      //  console.log('ROLE')
       } else {

       } 
    },error : (err) => {

      console.error("Error in fetching all getRoleList");
    }
  }
)
}
branchData:any=[]
branchList(){

 this.AirManagementService
 .branchlist()
 .subscribe({
   next : (res:any) => {
     if(res) {
    this.branchData=res
  
     } else {
     
     } 
   },error : (err) => {

   }
 }
)
}

tenantslist(){

  this.AirManagementService
  .tenantlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data=res
     this.tenantsList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}



searchQuery: any = '';
DataEntity:any=[]

filteredEntities: any[] = [...this.DataEntity]; // Clone the original data

// Function to filter the entities based on the search query
filterEntities() {

  this.filteredEntities = this.DataEntity.filter((item:any) =>
    item.entityName.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim())
  );

  
}


searchCarrierQuery: any = '';

filteredCarrier: any[] = [...this.carrierList]; // Clone the original data

// Function to filter the entities based on the search query

filterCarrier(frequentDetail: any) {
  const query = frequentDetail.searchCarrierQuery?.toLowerCase().trim() || '';
  frequentDetail.filteredCarrier = this.carrierList.filter((item: any) =>
    item.carrierName.toLowerCase().includes(query) ||
    item.airlineDesignatorCode.toLowerCase().includes(query)
  );
}
dataEntitylist(){

  this.DataEntityService
 .listEntities(this.userProfileData?.parentUserUid)
 .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res?.filter((item:any)=>item.isEnabled===true)


     this.DataEntity=data
    this.filterEntities()
      } else {
     
      } 
    },error : (err) => {

  }
  }
)
}
corporateUsers:any=[]
getCorporateUsers(){
  if(this.userProfileData){
   
  this.userProfileService
  
  .getCorporateUserListbyId(this.userProfileData.parentUserUid||'')
  .subscribe({
    next : (res:any) => {
      if(res) {
       
       let data:any
       data=res 
      //  console.log(data)
       this.corporateUsers=data
       this.corporateUsers=this.corporateUsers.filter((item:any) => item.userBookingProfile?.firstName && item.userBookingProfile?.firstName.trim() !== '');

       this.filterCorporateUsers() 
      

      } else {    
      } 
    },error : (err) => {

      
    }
  }
)}
}
searchUserQuery: any = '';

filteredCorporateUsers: any[] = [...this.corporateUsers]; // Clone the original data

filterCorporateUsers() {

  this.filteredCorporateUsers = this.corporateUsers.filter((item:any) =>
    item?.userBookingProfile?.firstName?.toLowerCase().trim().includes(this.searchUserQuery.toLowerCase().trim())||
    item?.userBookingProfile?.username?.toLowerCase().trim().includes(this.searchUserQuery.toLowerCase().trim())

  );

  
}


businessGroupList:any=[]
businessGrouplist(){

 this.AirManagementService
 .businessGrouplist()
 .subscribe({
   next : (res:any) => {
     if(res) {
       let data=res
    this.businessGroupList=data
    this.filterBusinessEntities()
     } else {
     
     } 
   },error : (err) => {

   }
 }
)
}

searchBusinessQuery:any=""

filteredBusinessGroup: any[] = [...this.businessGroupList]; // Clone the original data

// Function to filter the entities based on the search query
filterBusinessEntities() {

this.filteredBusinessGroup= this.businessGroupList.filter((item:any) =>
item.code.toLowerCase().trim().includes(this.searchBusinessQuery.toLowerCase().trim())
);


}
cardtypedata:any=[]
bankdata:any=[]
cardTypeList(){

  this.PaymentConfigService
  .cardtypeList()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.cardtypedata=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

bankList(){

  this.PaymentConfigService
  .bankList()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.bankdata=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

CardLenght:any=16
changeCardType(item:any){
 if (item.value==='AMEX'){
  this.CardLenght=15
 }else if(item.value==='BTA'){
  this.CardLenght=15
 }else{
  this.CardLenght=16
 }
}

mmYyyyValidator(control:any) {
  const value = control.value;

  if (!value) {
    return null; // Empty value is valid (you can adjust this based on your requirements)
  }

  // MM/YYYY pattern regex
  const regex = /^(0[1-9]|1[0-2])\/\d{4}$/;

  if (!regex.test(value)) {
    return { invalidFormat: true };
  }

  // Split the input value into month and year
  const [month, year] = value.split('/').map(Number);

  // Create a new date object using the provided month and year
  const inputDate = new Date(year, month - 1); // Note: JavaScript months are zero-based

  // Get the current date
  const currentDate = new Date();

  // Check if the input date is before the current date
  return inputDate >= currentDate ? null : { pastDate: true };

  
}


AddCreditCard(){
    

 
  

  this.PaymentConfigService.savecreditCard(this.userCardFg.value)
  .subscribe({
    next : (res) => {
      if(res.status==200 || res.status==201) {
        this.toastMsgService.setMsg({msg : "Credit Card Added Successfully!",msgTitle : "Success", msgType : "I"});
        this.userCardFg=this.fb.group({
          "cardType":['',[Validators.required]],
          "bankName":['',[Validators.required]],
          "cardNumber":['',[Validators.required]],
          "expiryDate" : ['',[Validators.required,this.mmYyyyValidator]],
      "holderName":['',[Validators.required]],
          
      
        })
        this.creditList()

      } else {
        const body : any = res.body;
        this.registercreditCardErrorMsg(res.status,body?.result);
      } 

    },error : (err) => {

      this.registercreditCardErrorMsg(err.status,err.error);
    }
  }
)
}

registercreditCardErrorMsg(status : number,msg : string) {

if(status >=500) {
  this.toastMsgService.setMsg({msg : "Failed to save Credit Card",msgTitle : "Warning", msgType : "W"});
} else {

  this.toastMsgService.setMsg({msg : "Failed to save Credit Card",msgTitle:  "Warning", msgType : "W"});
} 
}

CreditData:any=[]

cardVerification:boolean=false
disabledCards(): boolean {
  return !this.cardVerification || this.userCardFg.invalid;
}
creditList(){

  this.PaymentConfigService
  .creditCardList()
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data=res
     this.CreditData=data
    //  console.log(this.CreditData)
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
cvv:any
card:any
visible:boolean=false
JusPayLink(card:any){
  this.cvv=''
this.card=card
this.visible=true
}
initiatePayment(){
  sessionStorage.setItem('urlAgentPath',this.router.routerState.snapshot.url);

  this.visible=false

let request:any=
  {
    // "cardNumber":this.card,
    "tokenize":true,
    "saveToLocker":true,
    "cardCvv":this.cvv,
    "paymentCardId":this.card?.cardId,
    "paymentCardUuid":this.card?.cardUuid,
    "customerId":this.userUuid
    
}

  this.PaymentConfigService
  .JusPayLink(request)
  .subscribe({
    next : (res:any) => {
      if(res) {
        // console.log(res)
        let data=res
        data=data?.body?.juspayCreateOrder?.payment
    //  this.CreditData=data
      if(data?.authentication){
      let  url=data?.authentication?.url;
        window.open(url, '_self');
      


   
      }else{
        this.toastMsgService.setMsg({msg : "Failed to Tokenized",msgTitle : "Warning", msgType : "W"});

      }




    //  console.log(data)
      } else {
        this.toastMsgService.setMsg({msg : "Failed to Tokenized",msgTitle : "Warning", msgType : "W"});

      
      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : "Failed to Tokenized",msgTitle : "Warning", msgType : "W"});

    }
  }
)
}
removeCard(){
  this.DialogService.open({msg :'Are you sure you want to Remove the Card?',title : "Information",buttonType : "OkCancel"})
       
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Ok") {
      
           }})
}
showReporting:boolean=false
OnClickRepo(){
  this.showReporting= !this.showReporting
}


selectedFile: File | null = null;

onFileSelected(event: FileUploadHandlerEvent,passportNumber:any) {
  // const input = event.target as HTMLInputElement;
  const files: File[] = event.files;

  if (files && files.length > 0) {
    this.selectedFile = files[0];
    // console.log('File selected:', this.selectedFile);
    
    // You can directly call upload() here if needed
  }
}

upload(ops: OverlayPanel,passportNumber:any) {
  if (!this.selectedFile) return;

  const formData = new FormData();
  formData.append('file', this.selectedFile);

  const jsonData = {
    bookingProfileUuid: this.userProfileData?.bookingProfileUuid||'',
    userUid: this.userData?.userUid,
    passportNumber:passportNumber
  };

  formData.append('data', new Blob([JSON.stringify(jsonData)], { type: 'application/json' }));






  this.userService
  .passportUpdate(formData)
  .subscribe({
    next : (res:any) => {
      ops.hide();
      this.toastMsgService.setMsg({msg : "File Updated Successfully!",msgTitle : "Success", msgType : "I"});
      this.getUserData()
      if(res) {
        // console.log(res)
        let data=res

      } else {

      
      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : "Failed to Upload",msgTitle : "Warning", msgType : "W"});

    }
  }
)
}

isValidPassport(passport: string): boolean {
  const passportRegex = /^[A-PR-WY][0-9]{6,8}$/;
  return !!passport && passportRegex.test(passport);
}

downloadPassport(passport:any){
  this.userService
  .downloadPassport(passport)
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
      //  console.log(data)

     

      var fileName = passport;
var blob = data; // Assuming 'data' contains your PDF data

var mimeType;
let type:any
type=passport.split('.')[1]
    switch(type) {
        case 'pdf':
            mimeType = 'application/pdf';
            break;
        case 'image':
            mimeType = 'image/*'; // Change this to 'image/jpeg' for JPEG images
            break;
        case 'excel':
            mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            break;
            case 'eml':
                mimeType = 'message/rfc822';
                break;
            case 'msg':
                mimeType = 'application/vnd.ms-outlook';
                break;
        default:
            mimeType = 'application/octet-stream'; // Fallback for unknown types
    }

var file = new Blob([blob], { type: mimeType });

// Create a download link
var a = document.createElement("a");
a.href = window.URL.createObjectURL(file);
a.download = fileName;

// Append the link to the document
document.body.appendChild(a);

// Trigger a click on the link to start the download
a.click();

// Remove the link from the document after the download is initiated
document.body.removeChild(a);
      } else {    
      } 
    },error : (err) => {


    }
  }
)
}
}
